/**
 * Hooks exported here are imported and initialized in `useGlobalABTests` hook
 */
import { useABTest_PriceEstimate } from '@bridebook/web/lib/ab-tests/tests/global/LIVE-25246_PriceEstimate';
import { useABTest_LIVE_27666_EnquiryFormImprovements } from './LIVE-27666_EnquiryFormImprovements';
import { useABTest_AppendIncompleteSearchResults } from './LIVE-27907_AppendIncompleteSearchResults';

export const globalABTests: (() => void)[] = [
  useABTest_PriceEstimate,
  useABTest_LIVE_27666_EnquiryFormImprovements,
  useABTest_AppendIncompleteSearchResults,
];
